var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dp-pad"},[_c('img',{staticClass:"dp-pad-bg",attrs:{"src":require("@/assets/phone.png"),"alt":""}}),_c('div',{staticClass:"dp-pad-iframe"},[_c('iframe',{attrs:{"src":"https://dp.djplus.cn"}})])])
}]

export { render, staticRenderFns }